import React from "react";
import starIcon from '../../assets/images/star-icon.svg'
export default function Marqueetext() {
  const items = [
    "FRONTEND DEVELOPMENT",
    "REACT.JS",
    "TAILWIND CSS",
    "NODE.JS",
    "UI/UX DESIGN",
    "MONGO DB",
    "EXPRESS",
    "JAVASCRIPT",
    "CSS",
    "BOOTSTRAP",
    "JQUERY",
    "MATERIAL UI",
    "GITHUB",
    "BACKEND DEVELOPMENT",
  ];

  return (
    <div
      className="w-full overflow-hidden py-[20px]"
      style={{
        background: "linear-gradient(254.54deg, #F0FF6C 0.03%, #6BFDD9 100%)",
      }}
    >
      <div className="flex w-max animate-marquee">
        {items.concat(items).map((text, index) => (
          <span
            key={index}
            className="flex items-center font-bold text-[20px] md:text-[24px] lg:text-[30px] text-[#163031] uppercase"
          >
            <img
              src={starIcon}
              alt="star"
              className="w-[30px] h-[30px] mx-6"
            />
            {text}
          </span>
        ))}
      </div>
    </div>
  );
}
